"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthErrorType = exports.OAuthSuccessType = exports.OAuthActionType = exports.AuthProvider = void 0;
var AuthProvider;
(function (AuthProvider) {
    AuthProvider["PASSWORD"] = "password";
    AuthProvider["GOOGLE"] = "google";
})(AuthProvider || (exports.AuthProvider = AuthProvider = {}));
var OAuthActionType;
(function (OAuthActionType) {
    OAuthActionType["LINK"] = "link";
    OAuthActionType["LOGIN"] = "login";
    OAuthActionType["VERIFY"] = "verify";
    OAuthActionType["SIGNUP"] = "signup";
})(OAuthActionType || (exports.OAuthActionType = OAuthActionType = {}));
var OAuthSuccessType;
(function (OAuthSuccessType) {
    OAuthSuccessType["LOGIN_SUCCESS"] = "login_success";
    OAuthSuccessType["SIGNUP_SUCCESS"] = "signup_success";
    OAuthSuccessType["LINK_SUCCESS"] = "link_success";
    OAuthSuccessType["VERIFY_SUCCESS"] = "verify_success";
})(OAuthSuccessType || (exports.OAuthSuccessType = OAuthSuccessType = {}));
var OAuthErrorType;
(function (OAuthErrorType) {
    OAuthErrorType["OAUTH_ERROR"] = "oauth_error";
    OAuthErrorType["LOGIN_ERROR"] = "login_error";
    OAuthErrorType["SIGNUP_ERROR"] = "signup_error";
    OAuthErrorType["LINK_ERROR"] = "link_error";
    OAuthErrorType["VERIFY_ERROR"] = "verify_error";
    OAuthErrorType["MISSING_PARAMS"] = "missing_params";
    OAuthErrorType["INIT_FAILED"] = "oauth-init-failed";
    OAuthErrorType["INVALID_ACTION"] = "invalid-action";
    OAuthErrorType["ACCOUNT_NOT_LINKED"] = "account-not-linked";
    OAuthErrorType["EMAIL_MISSMATCH"] = "email-mismatch";
})(OAuthErrorType || (exports.OAuthErrorType = OAuthErrorType = {}));
